import React, { useEffect, useState } from "react";
import { navigate, Link } from "gatsby";
import styled from "styled-components";

import headerLogo from "../../../static/images/logo/logo.svg";
import headerLogo2 from "../../../static/images/hero/image/logo-2.svg";
import headerLogoMini from "../../../static/images/logo/logo-mini.png";
import linkedin from "../../../static/images/header/Linkedin.svg";
import linkedinBlue from "../../../static/images/header/Linkedin-blue.svg";
import linkedinHover from "../../../static/images/header/Linkedin-hover.svg";
import twitter from "../../../static/images/header/Twitter.svg";
import twitterHover from "../../../static/images/header/Twitter-hover.svg";
import ButtonStyled from "../../components/library/Button.js";

const Header = ({ path }) => {
  const [navBar, setNavBar] = useState(0);

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
  });

  const listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;
    setNavBar(scrolled);
  };

  const goToContactDetails = () => {
    navigate("/contact-us/#contact-details");
  };

  useEffect(() => {
    playAnimation();
  });

  const playAnimation = () => {
    //document.getElementById('header-animation').style = "@-webkit-keyframes fadeinHome {0% {top:-100px;} 80% {top:-100px;} 100% {top: 0;}}"
  };

  return (
    <div id={"header-animation"}>
      {path !== "/404" &&
        path !== "/privacy-policy/" &&
        path !== "/terms-of-use/" && (
          <HeaderStyle path={path}>
            <header className={"header"}>
              <Link to={"/"}>
                <img src={headerLogo2} className={"header-logo"} alt={"logo"} />
              </Link>
              <nav className={"main-nav"}>
                <ul className={"main-nav-list"}>
                  {/*<li>*/}
                  {/*    <a to={'http://linkedin.com'}>*/}
                  {/*        <Linkedin white/>*/}
                  {/*    </a>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*    <a to={'http://twitter.com'}>*/}
                  {/*        <Twitter/>*/}
                  {/*    </a>*/}
                  {/*</li>*/}
                  <li>
                    <ButtonStyled
                      secondary
                      type={"button"}
                      onClick={() => goToContactDetails()}
                      label={"Contact us"}
                    />
                  </li>
                </ul>
              </nav>
            </header>
          </HeaderStyle>
        )}
      {navBar > 0.15 &&
        path !== "/404" &&
        path !== "/privacy-policy/" &&
        path !== "/terms-of-use/" && (
          <HeaderScrollStyle>
            <header className={"header"}>
              <Link to={"/"}>
                <img
                  src={headerLogoMini}
                  className={"header-logo"}
                  alt={"logo"}
                />
              </Link>
              <Menu>
                <List>
                  <Link to={"/who-we-are/"}>
                    <ListItem>
                      <span>Who we are</span>
                    </ListItem>
                  </Link>
                  <Link to={"/what-we-build/"}>
                    <ListItem>
                      <span>What we build</span>
                    </ListItem>
                  </Link>
                  <Link to={"/sectors/"}>
                    <ListItem>
                      <span>Where we focus</span>
                    </ListItem>
                  </Link>
                  <Link to={"/contact-us/"}>
                    <ListItem>
                      <span>How to connect</span>
                    </ListItem>
                  </Link>
                </List>
              </Menu>
              <nav className={"main-nav"}>
                {/*<a to={'http://linkedin.com'}>*/}
                {/*    <Linkedin/>*/}
                {/*</a>*/}
                <ButtonStyled
                  secondary
                  type={"button"}
                  onClick={() => goToContactDetails()}
                  label={"Contact us"}
                />
              </nav>
            </header>
          </HeaderScrollStyle>
        )}
      {console.log(path)}
      {(path === "/404" ||
        path === "/privacy-policy/" ||
        path === "/terms-of-use/") && (
        <HeaderScrollStyle>
          {console.log("HERE")}
          <header className={"header"}>
            <Link to={"/"}>
              <img
                src={headerLogoMini}
                className={"header-logo"}
                alt={"logo"}
              />
            </Link>
            <Menu>
              <List>
                <Link to={"/who-we-are/"}>
                  <ListItem>
                    <span>Who we are</span>
                  </ListItem>
                </Link>
                <Link to={"/what-we-build/"}>
                  <ListItem>
                    <span>What we build</span>
                  </ListItem>
                </Link>
                <Link to={"/sectors/"}>
                  <ListItem>
                    <span>Where we focus</span>
                  </ListItem>
                </Link>
                <Link to={"/contact-us/"}>
                  <ListItem>
                    <span>How to connect</span>
                  </ListItem>
                </Link>
              </List>
            </Menu>
            <nav className={"main-nav"}>
              {/*<a to={'http://linkedin.com'}>*/}
              {/*    <Linkedin/>*/}
              {/*</a>*/}
              <ButtonStyled
                secondary
                type={"button"}
                onClick={() => goToContactDetails()}
                label={"Contact us"}
              />
            </nav>
          </header>
        </HeaderScrollStyle>
      )}
    </div>
  );
};

export default Header;

const HeaderStyle = styled.div`
  @keyframes fadeinHome {
    0% {
      top: -100px;
    }
    80% {
      top: -100px;
    }
    100% {
      top: 0px;
    }
  }
  @-moz-keyframes fadeinHome {
    /* Firefox */
    0% {
      top: -100px;
    }
    80% {
      top: -100px;
    }
    100% {
      top: 0px;
    }
  }
  //@-webkit-keyframes fadeinHome { /* Safari and Chrome */
  //  0% {
  //    top: -100px;
  //  }
  //  80% {
  //    top: -100px;
  //  }
  //  100% {
  //    top: 0px;
  //  }
  //}
  @-o-keyframes fadeinHome {
    /* Opera */
    0% {
      top: -100px;
    }
    80% {
      top: -100px;
    }
    100% {
      top: 0px;
    }
  }
  z-index: 2;

  animation: ${({ path }) => (path === "/" ? "fadeinHome 2.8s" : "none")};
  -moz-animation: ${({ path }) => (path === "/" ? "fadeinHome 2.8s" : "none")};
  -webkit-animation: ${({ path }) =>
    path === "/" ? "fadeinHome 2.8s" : "none"};
  -o-animation: ${({ path }) => (path === "/" ? "fadeinHome 2.8s" : "none")};

  position: absolute;
  top: 0px;
  width: 100%;
  padding: 2rem 12rem;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-logo {
    width: 210px;
    height: 75px;
  }

  .main-nav-list {
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;

    li {
      margin-left: 40px;
    }
  }

  box-shadow: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.breakpoints.mobile} {
    display: none;
  }

  @keyframes fadein {
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes fadein {
    /* Firefox */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadein {
    /* Safari and Chrome */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes fadein {
    /* Opera */
    from {
      opacity: 0.5;
    }
    to {
      opacity: 1;
    }
  }
`;

const HeaderScrollStyle = styled.div`
  position: fixed;
  width: 100%;
  padding: 1.6rem 12rem;
  top: 0px;
  background: #ffffff;
  z-index: 2;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    padding: 1.6rem 2.4rem;
  }

  .header {
    display: grid;
    grid-template-columns: 1fr 6fr 2fr;

    a {
      display: flex;
      align-items: center;
    }
  }

  .header-logo {
    height: 40px;
  }

  .main-nav {
    justify-self: flex-end;
    align-self: center;
    list-style: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    a {
      margin-right: 4rem;
    }
    button {
      height: 45px;
    }
  }

  box-shadow: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.breakpoints.mobile} {
    display: none;
  }

  animation: fadein 0.6s;
  -moz-animation: fadein 0.6s; /* Firefox */
  -webkit-animation: fadein 0.6s; /* Safari and Chrome */
  -o-animation: fadein 0.6s; /* Opera */

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-moz-keyframes fadein {
    /* Firefox */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fadein {
    /* Safari and Chrome */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-o-keyframes fadein {
    /* Opera */
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const ListItem = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 1.6rem;
  line-height: 2.8rem;
  margin: 0rem 3rem 0rem 0rem;
  padding: 1.5rem 0rem;
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
  width: fit-content;
  text-transform: capitalize;
  // @media ${({ theme }) => theme.breakpoints.small_height} {
  //   font-size: 2rem;
  // }
  span:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.secondary};
    visibility: hidden;
    transform: scaleX(0);
    transition: 0.25s linear;
  }

  span:hover:before,
  span:focus:before {
    visibility: visible;
    transform: scaleX(1);
  }
`;
const Menu = styled.div`
  align-self: center;
`;

const Linkedin = styled.div`
  width: 21px;
  height: 21px;
  background-image: url(${({ white }) => (white ? linkedin : linkedinBlue)});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;

  &:hover {
    background-image: url(${linkedinHover});
    animation: fadein 0.6s;
    -moz-animation: fadein 0.6s; /* Firefox */
    -webkit-animation: fadein 0.6s; /* Safari and Chrome */
    -o-animation: fadein 0.6s; /* Opera */
  }
`;
const Twitter = styled.div`
  width: 21px;
  height: 21px;
  background-image: url(${twitter});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;

  &:hover {
    animation: fadein 0.6s;
    -moz-animation: fadein 0.6s; /* Firefox */
    -webkit-animation: fadein 0.6s; /* Safari and Chrome */
    -o-animation: fadein 0.6s; /* Opera */
    background-image: url(${twitterHover});
  }
`;
